import { computed, ComputedRef } from 'vue';
import { useChartStore } from '@/stores/chartStore';

let downloadFileName: ComputedRef<string> | undefined;

export function useDownloadFileName() {
  const chartStore = useChartStore();

  downloadFileName = downloadFileName ?? computed(() => {
    return `${chartStore.symbol}.png`;
  });

  return {
    downloadFileName
  };
}
